<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="accinventory-by-masterpayer"
  >
    <v-layout wrap>
      <v-flex md4>
        <formAdminMonthlyCrossChargeFilter :view="'master-payer'"/>
      </v-flex>
      <v-layout wrap>
        <v-flex
          md12
          lg4>
          <material-card
            color="orange"
            title="PPA"
          >

            <v-data-table
              :headers="ppa_header"
              :items="ppaAccounts"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="font-weight-light text-warning text--darken-3"
                  v-text="header.text"
                />
              </template>

              <template
                slot="items"
                slot-scope="props"
              >
                <td class="mp-col">
                  <router-link
                    :to="'/admin/financial-administration/monthly-cross-charge/master-payer/'+ props.item.PayerAccountId + '?agreement=ppa'"
                    tag="div">
                    {{ props.item.PayerAccountId }}
                  </router-link>
                </td>

                <td class="mp-col">
                  <v-icon small color="primary" title="PROCESS MONTHLY BILLING" @click="selectMasterPayerAccount(props.item.PayerAccountId)">
                    more_vert
                  </v-icon>
                </td>
                
              </template>

            </v-data-table>
            <Can
              i="manage"
              a="admin">
              <HelperCsvDownload
                :data="ppaAccounts"
                class="mp-download"/>
            </Can>
          </material-card>
        </v-flex>

        <v-flex
          md12
          lg4>
          <material-card
            color="orange"
            title="SPP"
          >
            
            <v-data-table
              :headers="spp_header"
              :items="sppAccounts"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="font-weight-light text-warning text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <td class="mp-col">
                  <router-link
                    :to="'/admin/financial-administration/monthly-cross-charge/master-payer/'+ props.item.PayerAccountId + '?agreement=spp'"
                    tag="div">
                    {{ props.item.PayerAccountId }}
                  </router-link>
                </td>

                <td class="mp-col">
                  <v-icon small color="primary" title="PROCESS MONTHLY BILLING" @click="selectMasterPayerAccount(props.item.PayerAccountId)">
                    more_vert
                  </v-icon> 
                </td>

              </template>
            </v-data-table>
            <Can
              i="manage"
              a="admin">
              <HelperCsvDownload
                :data="sppAccounts"
                class="mp-download"/>
            </Can>
          </material-card>
        </v-flex>

        <v-flex
          md12
          lg4>
          <material-card
            color="orange"
            title="Single Payer"
          >
            <v-data-table
              :headers="spp_header"
              :items="spAccounts"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="font-weight-light text-warning text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <td class="mp-col">
                  <router-link
                    :to="'/admin/financial-administration/monthly-cross-charge/master-payer/'+ props.item.PayerAccountId + '?agreement=sp'"
                    tag="div">
                    {{ props.item.PayerAccountId }}
                  </router-link>
                </td>

                <td class="mp-col">
                  <v-icon small color="primary" title="PROCESS MONTHLY BILLING" @click="selectMasterPayerAccount(props.item.PayerAccountId)">
                    more_vert
                  </v-icon> 
                </td>

              </template>
            </v-data-table>
            <Can
              i="manage"
              a="admin">
              <HelperCsvDownload
                :data="spAccounts"
                class="mp-download"/>
            </Can>
          </material-card>
        </v-flex>

        <v-flex
          md12
          lg4>
          <material-card
            color="orange"
            title="Other"
            text="AWS Non PPA/SPP Accounts"
          >
            <v-data-table
              :headers="other_header"
              :items="otherAccounts"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="font-weight-light text-warning text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <td class="mp-col">
                  <router-link
                    :to="'/admin/financial-administration/monthly-cross-charge/master-payer/'+ props.item.PayerAccountId + '?agreement=other'"
                    tag="div">
                    {{ props.item.PayerAccountId }}
                  </router-link>
                </td>

                <td class="mp-col">
                  <v-icon small color="primary" title="PROCESS MONTHLY BILLING" @click="selectMasterPayerAccount(props.item.PayerAccountId)">
                    more_vert
                  </v-icon> 
                </td>

              </template>
            </v-data-table>
            <Can
              i="manage"
              a="admin">
              <HelperCsvDownload
                :data="otherAccounts"
                class="mp-download"/>
            </Can>
          </material-card>
        </v-flex>

        <v-flex
          md12
          lg4>
          <material-card
            color="orange"
            title="All"
          >
            <v-data-table
              :headers="all_header"
              :items="all"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="font-weight-light text-warning text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <td class="mp-col">
                  <router-link
                    :to="'/admin/financial-administration/monthly-cross-charge/master-payer/'+ props.item.PayerAccountId + '?agreement=all'"
                    tag="div">
                    {{ props.item.PayerAccountId }}
                  </router-link>
                </td>

                <td class="mp-col">
                  <v-icon small color="primary" title="PROCESS MONTHLY BILLING" @click="selectMasterPayerAccount(props.item.PayerAccountId)">
                    more_vert
                  </v-icon> 
                </td>
                
              </template>
            </v-data-table>
            <Can
              i="manage"
              a="admin">
              <HelperCsvDownload
                :data="all"
                class="mp-download"/>
            </Can>
          </material-card>
        </v-flex>
        
      </v-layout>
    </v-layout>

    <v-dialog
      v-model="showBillingPopUp"
      persistent
      max-width="600px">
      <v-card>
        
        <v-card-title>
          <span class="headline">
            <v-icon medium color="primary">cloud_download</v-icon> AWS Billing Account ({{this.selectedMasterPayer}})
          </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md10
                xl10>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="billingDate"
                      label="Select Biling Month"
                      prepend-icon="event_note"
                      readonly
                      v-on="on"
                    />
                  </template>

                  <v-date-picker
                    v-model="billingDate"
                    @input="menu2 = false"
                  />

                </v-menu>

                <v-select
                  prepend-icon="mdi-dialpad"
                  v-model="actionType"
                  :items="['New','Reprocess']"
                  attach
                  data-vv-name="Process Type"
                  data-vv-validate-on="blur"
                >
                  <template slot="label"> <span v-html="`Process Type <span class='required'>*</span>`"/></template>
                </v-select>

                <v-banner
                  style="color:orange" 
                  two-line
                  v-if="billingProcessStatus"
                >
                  {{ billingProcessStatus }}!
                </v-banner>


              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout
            align-end
            justify-end>

            <v-btn
              color="orange darken-1"
              text
              @click="close()">Close</v-btn>
            <v-btn
              :loading ="loadingRequest"
              color="orange darken-1"
              text
              @click="processMonthlyBilling()">Submit</v-btn>
          </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
// Utilities
import {
  mapState
} from 'vuex'

export default {
  data () {
    return {
      ppa_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'AWS_Support_Type'
        },
        {
          sortable: false,
          text: '',
          value: ''
        },
      ],
      spp_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'AWS_Support_Type'
        },
        {
          sortable: false,
          text: '',
          value: ''
        },
      ],
      sp_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'AWS_Support_Type'
        },
        {
          sortable: false,
          text: '',
          value: ''
        },
      ],
      other_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'AWS_Support_Type'
        },
        {
          sortable: false,
          text: '',
          value: ''
        },
      ],
      all_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'AWS_Support_Type'
        },
        {
          sortable: false,
          text: '',
          value: ''
        },
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      },
      menu2: false,
      hover: false,
      actionType: 'New',
      selectedMasterPayer: null,
      showBillingPopUp: false,
      billingDate: new Date().toISOString().substr(0, 10),
    }
  },

  computed: {
    ...mapState('admin/financialAdministration', ['allAccounts', 'loadingRequest', 'billingProcessStatus'] ),
    ppaAccounts () {
      let uniquePpaAccounts = []
      let ppaAccounts = this.allAccounts.filter(item => item.Contract.toLowerCase() === 'ppa')

      return ppaAccounts.filter(account => {
        if (!uniquePpaAccounts.includes(account.PayerAccountId)) {
          uniquePpaAccounts.push(account.PayerAccountId)
          return account
        }
      })
    },
    sppAccounts () {
      let uniqueSppAccounts = []
      let sppAccounts = this.allAccounts.filter(item => item.Contract.toLowerCase() === 'spp')

      return sppAccounts.filter(account => {
        if (!uniqueSppAccounts.includes(account.PayerAccountId)) {
          uniqueSppAccounts.push(account.PayerAccountId)
          return account
        }
      })
    },
    spAccounts () {
      let uniqueSpAccounts = []
      let spAccounts = this.allAccounts.filter(item => item.Contract.toLowerCase().indexOf('spp -') !== -1)

      return spAccounts.filter(account => {
        if (!uniqueSpAccounts.includes(account.PayerAccountId)) {
          uniqueSpAccounts.push(account.PayerAccountId)
          return account
        }
      })
    },
    otherAccounts () {
      let uniqueOtherAccounts = []
      let otherAccounts = this.allAccounts.filter(item => !['sp', 'spp', 'ppa'].includes(item.Contract.toLowerCase()) && item.Contract.toLowerCase().indexOf('spp -') === -1)

      return otherAccounts.filter(account => {
        if (!uniqueOtherAccounts.includes(account.PayerAccountId)) {
          uniqueOtherAccounts.push(account.PayerAccountId)
          return account
        }
      })
    },
    all () {
      let uniqueOtherAccounts = []

      return this.allAccounts.filter(account => {
        if (!uniqueOtherAccounts.includes(account.PayerAccountId)) {
          uniqueOtherAccounts.push(account.PayerAccountId)
          return account
        }
      })
    }
  },
  methods: {
    complete (index) {
      this.list[index] = !this.list[index]
    },
    selectMasterPayerAccount(MP_Id_Type) {
      this.showBillingPopUp = true
      this.selectedMasterPayer = MP_Id_Type
    },
    close() {
      this.$store.state['admin/financialAdministration'].billingProcessStatus = null
      this.showBillingPopUp = false
    },
    processMonthlyBilling() {
      this.$store.state['admin/financialAdministration'].billingProcessStatus = null
      let reqParams = {
        masterPayer: this.selectedMasterPayer,
        billingMonth: this.billingDate.substr(0, 7),
        processType: this.actionType
      }
      this.$store.dispatch('admin/financialAdministration/processAWSMonthlyBilling', reqParams)
    }
  }
}

</script>
<style lang='scss' scoped>
  .v-input__control, .v-input__slot, .v-select__slot {
			border: 0;
		}
  .accinventory-by-masterpayer {
    .mp-col {
      cursor: pointer;
      &:hover {
        font-weight: 500;
      }
    }

    .mp-download{
      position: absolute;
      bottom: 10px;
    }
  }
</style>
